class CollectionColumnSwitcher {
  constructor() {
    this.productGrid = document.getElementById('product-grid');
    this.mobileButtons = document.querySelector('.product-grid-facets-container__columns-mobile');
    this.desktopButtons = document.querySelector('.product-grid-facets-container__columns-desktop');

    this.init();
  }

  init() {
    if (!this.productGrid || (!this.mobileButtons && !this.desktopButtons)) return;

    // Initialize mobile buttons
    if (this.mobileButtons) {
      this.mobileButtons.querySelectorAll('.product-grid-facets-container__columns-button').forEach((button) => {
        button.addEventListener('click', () => this.handleColumnSwitch(button, true));
      });
    }

    // Initialize desktop buttons
    if (this.desktopButtons) {
      this.desktopButtons.querySelectorAll('.product-grid-facets-container__columns-button').forEach((button) => {
        button.addEventListener('click', () => this.handleColumnSwitch(button, false));
      });
    }
  }

  handleColumnSwitch(clickedButton, isMobile) {
    const buttonContainer = isMobile ? this.mobileButtons : this.desktopButtons;

    // Remove active class from all buttons in the container
    buttonContainer.querySelectorAll('.product-grid-facets-container__columns-button').forEach((button) => {
      button.classList.remove('active');
    });

    // Add active class to clicked button
    clickedButton.classList.add('active');

    // Get the column type from the button's class
    const columnClass = clickedButton.dataset.columnClass;
    // const columnType = clickedButton.classList.contains('one-column')
    //   ? 'one'
    //   : clickedButton.classList.contains('two-columns')
    //   ? 'two'
    //   : 'three';

    // Update grid classes
    this.updateGridClasses(columnClass, isMobile);
  }

  updateGridClasses(columnClass, isMobile) {
    // Add new column classes based on the device type
    if (isMobile) {
      // Remove existing column classes
      this.productGrid.classList.remove('grid--1-col-tablet-down', 'grid--2-col-tablet-down');

      this.productGrid.classList.add(columnClass);
    } else {
      // Remove existing column classes
      this.productGrid.classList.remove(
        'grid--1-col-desktop',
        'grid--2-col-desktop',
        'grid--3-col-desktop',
        'grid--4-col-desktop',
        'grid--6-col-desktop'
      );

      this.productGrid.classList.add(columnClass);
    }
  }
}

// Initialize the column switcher when the DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CollectionColumnSwitcher();
});
